module.exports = __webpack_public_path__ + "img/sign.707decc6.svg";